export class Validation{
    static getDefaultValidator(form) {

        return FormValidation.formValidation(form, {
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap5({
                    rowSelector: '.fv-row',
                    eleInvalidClass: 'bg-light-danger is-invalid',
                    eleValidClass: ''
                }),
                declarative: new FormValidation.plugins.Declarative({html5Input: true})
            }
        });
    }

    static disableButton(button) {
        button?.setAttribute("disabled", "disabled");
        button?.setAttribute("data-kt-indicator", "on");
    }

    static enableButton(button) {
        button?.removeAttribute("disabled");
        button?.removeAttribute("data-kt-indicator");
    }

    static validateForm(e, validator, submitter) {
        e.preventDefault();

        const form = validator.form;
        if (validator) {
            validator.validate().then(status => {
                if (status === 'Valid') {
                    Validation.disableButton(submitter || e.submitter);
                    form.submit();
                }
            });
        }
    }

    static validateFormWithReCaptcha(e, validator, submitter) {
        e.preventDefault();

        const form = validator.form;
        if (validator) {
            validator.validate().then(function (status) {
                if (status === 'Valid') {

                    Validation.disableButton(submitter || e.submitter);

                    const recaptchaInput = form.querySelector("#RecaptchaResponse");
                    const siteKey = recaptchaInput.dataset.siteKey;

                    grecaptcha.ready(function () {
                        const action = recaptchaInput.dataset.action;
                        grecaptcha.execute(siteKey, {action: action}).then(function (token) {
                            recaptchaInput.value = token;

                            form.submit();
                        });
                    });
                }
            });
        }
    }

    static showFormError(errorText, errorTitle) {
        const errorContainer = document.querySelector("#error-alert");
        if(!errorContainer)
            return;

        errorContainer.style.display = "flex";
        errorContainer.querySelector(".alert-text").innerHTML = errorText;
    }

    static hideFormError() {
        const errorContainer = document.querySelector("#error-alert");
        if (!errorContainer)
            return;

        errorContainer.style.display = "none";
    }
}
